import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

// Define a prop type for conditional background styles
interface BackgroundProps {
  type?: "message" | string;
}

export const SeparatorBorder = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.gray40.main}`,
}));

export const BackgroundColor = styled(Box, {
  shouldForwardProp: (prop) => prop !== "type",
})<BackgroundProps>(({ theme, type }) => ({
  backgroundColor:
    type === "message" ? theme.palette.gray30.main : theme.palette.white.main,
  borderRadius: "4px",
}));

export const BackgroundColorOnCollapse = styled(Box, {
  shouldForwardProp: (prop) => prop !== "type",
})<BackgroundProps>(({ theme, type }) => ({
  backgroundColor:
    type === "message" ? theme.palette.gray30.main : theme.palette.white.main,
  borderRadius: "unset",
  borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",
}));

export const MessageCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.gray30.main,
  padding: "0px 16px 24px 16px",
  borderBottomLeftRadius: "4px",
  borderBottomRightRadius: "4px",
}));

export const MessageItemContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: 16,
});

export const MessageItemInnerContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
});

export const MyMessageItemInnerContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  width: "100%",
});

export const MyMessageItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.gray60.main,
  color: "white",
  padding: "10px 15px",
  borderRadius: 4,
  border: `1px solid ${theme.palette.gray60.main}`,
  textAlign: "right",
}));

export const MessageItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  color: theme.palette.gray80.main,
  padding: "10px 15px",
  borderRadius: 4,
  border: `1px solid ${theme.palette.gray40.main}`,
  textAlign: "left",
}));

export const MessageOrganizer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const AvatarStyled = styled(Box)({
  width: "40px",
  height: "40px",
  marginTop: 12,
  marginRight: 10,
});
